"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/free-mode";
import { parseMarkdown } from "./utils"; 

function Medhavibuzz({ course, courseSections }) {
  // Raw items from API — support multiple shapes (direct, attributes, or course-level)
  const rawItems =
    courseSections?.Medhavi_Buzz ||
    courseSections?.attributes?.Medhavi_Buzz ||
    course?.Medhavi_Buzz ||
    [];


  // Normalise API data -> flat slide objects
  const slides =
    rawItems
      ?.map((item) => {
        const media = item?.OnTheJobDescriptionImage;

        if (!media) return null;

        // Prefer formatted URLs if available
        const src =
          media.formats?.medium?.url ||
          media.formats?.large?.url ||
          media.formats?.small?.url ||
          media.url;

        if (!src) return null;

        return {
          src,
          alt:
            media.alternativeText ||
            item.OnTheJobTrainingImageText ||
            "Medhavi Buzz Image",
          caption:
            item.OnTheJobTrainingImageText ||  
            media.caption ||
            "",
        };
      })
      .filter(Boolean) || [];

  // Medhavi_Buzz_Description can be rich text array; render it as plain text
  const descriptionBlocks = course?.Medhavi_Buzz_Description;
  const description = (() => {
    if (!descriptionBlocks) return "";
    if (typeof descriptionBlocks === "string") return descriptionBlocks;
    if (Array.isArray(descriptionBlocks)) {
      return descriptionBlocks
        .map((blk) => {
          if (blk?.type === "paragraph") {
            return (blk.children || []).map((c) => c.text || "").join("");
          }
          return "";
        })
        .join("\n");
    }
    return "";
  })();

  // Duplicate for seamless marquee (not used by Swiper but kept for reference)
  const marqueeItems = [...slides, ...slides];

  // If there are no slides, do not render the section
  if (!slides || slides.length === 0) return null;

  return (
    <div className="mb-[50px] lg:mb-[70px]">
      {/* Header */}
      <div className="page-container mt-[50px] md:mt-[80px] xl:mt-[100px]">
        <h2 className="mb-[12px]">Medhavi Buzz</h2>
        <p className="text-black mb-[32px] md:mb-[40px] w-full md:w-[80%] xl:w-[80%]">
          {parseMarkdown(description)}
        </p>
      </div>

      {/* Swiper Slider (touch-friendly; responsive) */}
      <div className="relative">
        <div className="page-container">
          <Swiper
            modules={[FreeMode, Autoplay]}
            spaceBetween={16}
            slidesPerView={1.2}
            freeMode={false}
            loop={true}
            autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
            speed={800}
            breakpoints={{
              640: { slidesPerView: 1.2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="py-4"
          >
            {slides.map((item, index) => (
              <SwiperSlide key={`${item.src}-${index}`} className="w-auto">
                <div className={`relative overflow-hidden group transition-transform duration-700 hover:scale-105`}>
                  <div className="relative w-full h-52 md:h-64 lg:h-72 overflow-hidden shadow-lg">
                    <Image
                      src={item.src}
                      alt={item.alt}
                      fill
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                      className="object-cover"
                      unoptimized
                    />
                    <div
                      className="absolute inset-0 z-10 opacity-100 md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)",
                      }}
                    />
                  </div>

                  {item.caption && (
                    <div className="absolute bottom-2 md:bottom-4 left-4 right-4 z-20 text-white md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700">
                      <p className="text-[13px] md:text-[14px] opacity-90 w-full break-words leading-tight line-clamp-2 overflow-hidden">
                        {item.caption}
                      </p>
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default Medhavibuzz;
